export const Server = {
    backendURL: process.env.REACT_APP_API_URL,
    storageUrl: `${process.env.REACT_APP_API_URL}/storage/`
}
